export default __webpack_public_path__ + "static/media/activity-sleep-icon.83fa4113.svg";